import { Membership } from "../../typings/organization";
import "./resource";

class OrganizationService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "organizationResource"
    ];

    private $log: ng.ILogService;
    private $q: ng.IQService;
    private organizationResource;

    constructor(
        $log,
        $q,
        organizationResource
    ) {
        this.$log = $log;
        this.$q = $q;
        this.organizationResource = organizationResource;
    }

    public create(object) {
        return this.organizationResource()
            .save(object)
            .$promise
            .catch(error => {
                this.$log.error("Error while creating organization", error);
                return this.$q.reject(error);
            });
    }

    public update(organizationId, data) {
        return this.organizationResource().update({ id: organizationId }, data)
            .$promise
            .catch(error => {
                this.$log.error(`Error while updating organization ${organizationId}`, error, data);
                return this.$q.reject(error);
            });
    }

    public updateByAdmin(organizationId, data) {
        return this.organizationResource({"x-organization": organizationId})
            .update({ id: organizationId }, data)
            .$promise
            .catch(error => {
                this.$log.error(`Error while updating organization ${organizationId}`, data, error);
                return this.$q.reject(error);
            });
    }

    public getOrganization(organizationId) {
        return this.organizationResource({"x-organization": organizationId})
            .get({ id: organizationId })
            .$promise
            .catch(error => {
                this.$log.error(`Error while fetching organization ${organizationId}`, error);
                return this.$q.reject(error);
            });
    }

    public getFullOrganization(organizationId) {
        if (!organizationId) {
            return this.$q.reject("No organization id");
        }

        const promises = [];
        promises.push(this.getOrganization(organizationId));
        promises.push(this.getMediasByType(organizationId, "organization_gsc"));
        promises.push(this.getMediasByType(organizationId, "organization_logo"));
        promises.push(this.getMediasByType(organizationId, "organization_picture"));
        promises.push(this.getMediasByType(organizationId, "sale_conditions"));

        return this.$q.all(promises)
            .then((values: {}) => {
                const orga = values[0];
                if (!orga.medias) {
                    orga.medias = {};
                }

                orga.medias.organization_gsc = values[1].pop();
                orga.medias.organization_logo = values[2].pop();
                orga.medias.organization_picture = values[3];
                orga.medias.sale_conditions = values[4];

                return this.$q.resolve(orga);
            }).catch(error => {
                this.$log.error(`Error while fetching full organization ${organizationId}`, error);
                return this.$q.reject(error);
            });
    }

    public setMedia(organizationId, mediaId, type) {
        return this.organizationResource()
            .setMedia({ id: organizationId }, { type: type, media_id: mediaId })
            .$promise
            .catch(error => {
                this.$log.error("An error has occured", error);
                return this.$q.reject(error);
            });
    }

    public getMediasByType(organizationId, type) {
        return this.organizationResource()
            .getMedias({ id: organizationId, type: type })
            .$promise
            .catch(error => {
                this.$log.error("An error has occured", error);
                return this.$q.reject(error);
            });
    }

    public deleteMedia(mediaId) {
        return this.organizationResource()
            .deleteMedia({ id: mediaId })
            .$promise
            .catch(error => {
                this.$log.error("An error has occured", error);
                return this.$q.reject(error);
            });
    }

    public postMembership(organizationId: number, membership: Membership) {
        if (!membership) {
            return this.$q.resolve();
        }
        return (
            membership === Membership.Member
                ? this.organizationResource().setAsMember
                : this.organizationResource().setAsAdvertiser
        )({ id: organizationId }).$promise.catch(error => {
            this.$log.error("An error has occured", error);
            return this.$q.reject(error);
        });
    }
}

angular
    .module("thor.core.organization.service", [
        "thor.core.organization.resource"
    ])
    .service("organizationService", OrganizationService);
